<template>
  <div class="rebate-wapper">
    <div class="rebate_top">
      <span>返利:￥{{ reset.money || 0 }}</span>
      <span>票价:￥{{ reset.price || 0 }}</span>
      <span>数量:{{ reset.total || 0 }}</span>
    </div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <van-cell-group v-for="(item, index) in list" :key="index">
          <van-field label="昵称" :value="item.nickname" readonly />
          <van-field label="返利级别" :value="item.type" readonly />
          <van-field label="返利金额" :value="item.money" readonly />
          <van-field label="返利占比" :value="item.profit" readonly />
          <van-field label="票名" :value="item.ticket" readonly />
          <van-field label="票价" :value="item.price" readonly />
          <van-field label="时间" :value="item.createtime" readonly />
        </van-cell-group>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getMemberRebate } from '@/api/api-user';

export default {
  data() {
    return {
      reset: {},
      list: [],
      page: 1,
      loading: false,
      finished: false,
      refreshing: true,
    };
  },
  methods: {
    async onGet() {
      try {
        const { data, ...reset } = await getMemberRebate({ page: this.page });
        this.reset = reset;
        this.list = [...this.list, ...(data || [])];
        this.loading = false;
        if (this.reset.last_page <= this.page) {
          this.finished = true;
        } else {
          this.page += 1;
        }
      } catch (error) {}
    },
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.reset = {};
        this.refreshing = false;
      }
      setTimeout(() => {
        this.onGet();
      }, 600);
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.page = 1;
      this.onLoad();
    },
  },
};
</script>
<style lang="less" scoped>
.rebate-wapper {
  .rebate_top {
    width: 100%;
    line-height: 40px;
    display: flex;
    justify-content: space-around;
    position: fixed;
    top: 0;
    z-index: 3;
    background-color: white;
    box-shadow: 0 0 2px #eee;
  }
  .van-pull-refresh {
    min-height: 100vh;
    margin: 41px 0 50px;
  }
  .van-cell-group {
    margin: 0 8px 8px;
    .van-cell {
      background-color: #eee;
    }
    .van-cell:first-child {
      border-radius: 6px 6px 0 0;
    }
    .van-cell:last-child {
      border-radius: 0 0 6px 6px;
    }
  }
}
</style>
